/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'КАФЕДРАЛЬНЫЙ СОБОР ВАЛЕНСИИ',
        preferVisitRead: 'Prefereixo llegir',
        preferVisitListten: 'Prefereixo escoltar ',
        downloadAudio: '(descarregar audios)',
        download:'Downloading',
        errorDownload: 'Hi hagut un error en la descàrrega.',
        cancelDownload: 'Has cancel·lat la descàrrega.',
        initDownload: 'Пожалуйста, подождите',
        endDownload: 'Аудиозаписи загружены. Приятной экскурсии!',
        retry: 'Reintentar',
        noConnection: '',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Приветствие',
                author: 'Пожалуйста, используйте наушники',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Часовня Святого Себастьяна',
                author: 'Основание нефа',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Часовня Святого Апостола Петра',
                author: 'Правый боковой проход',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Часовня Св. Франциска де Борха',
                author: 'Правый боковой проход',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'Скошенное окно',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Главный алтарь',
                author: 'Главная часовня',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Ангелы-музыканты',
                author: 'Главная часовня',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Цимборио',
                author: 'Средокрестие',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Врата Милостыни',
                author: 'Правое крыло средокрестия',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Обходная галерея + Орган',
                author: 'Обходная галерея',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Воскресение Христово',
                author: 'Часовни славы',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Христос Доброй Смерти',
                author: 'Часовни славы',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Богоматерь де-ла-Кадира',
                author: 'Часовни славы',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'С. Дионисий и Ста. Маргарита',
                author: 'Часовни славы',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Апостольские ворота ',
                author: 'Левое крыло средокрестия',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Продолжение визита',
                author: 'Левый боковой проход',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Дарохранительница',
                author: 'Музей: Нижний этаж',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Злой разбойник + поклонение ',
                author: 'Музей: Нижний этаж',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Макеты',
                author: 'Музей: Второй этаж',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Апостолы',
                author: 'Музей: Второй этаж',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'Сомнение Святого Фомы ',
                author: 'Музей: Второй этаж',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Реликварий',
                author: 'Музей: Второй этаж',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Поругание',
                author: 'Музей: Второй этаж',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Коридор + искусство барокко',
                author: 'Музей: Второй этаж',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Археологические раскопки',
                author: 'Музей: Подземный этаж',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Хоровые книги + Тайная вечеря',
                author: 'Музей: Нижний этаж',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'Святой Грааль ',
                author: 'Часовня Святого Грааля',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Часовня Святого Грааля',
                author: 'Часовня Святого Грааля',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'Микалет',
                author: 'Основание нефа',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Титры',
                isCredits:true,
                author: '',
                description: 'Trama Media для Валенсийского Кафедрального собора.<br><br>© Кафедральный собор Валенсии.<br><br>Все права защищены.<br><br>',
                audio: '',
                idCreditImage: 30,
            },

        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/pусский.js